import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Buttton, CustomDatePicker, Indicators, Inputs, SelectO } from '..'
import { TbSearch } from 'react-icons/tb'

const SearchBar = ({ className,
    showDate,
    showSelect1,
    showSelect2,
    showSelect3,
    showSelect4,

    datepickermd,
    selectColmd1,
    selectColmd2,
    selectColmd3,
    selectColmd4,
    searchColmd,
    buttonColmd,

    datepickerxs,
    selectColxs1,
    selectColxs2,
    selectColxs3,
    selectColxs4,
    selectColxs,
    buttonColxs,

    datepickerlg,
    selectCollg1,
    selectCollg2,
    selectCollg3,
    selectCollg4,
    searchCollg,
    buttonCollg,

    searchGrpClassName,
    buttonClassname,
    cDateRangeClassname,
    select1Classname,
    select2Classname,
    select3Classname,
    select4Classname,

    classNameCol1,
    classNameCol2,
    classNameCol3,
    classNameCol4,
    classNameCol5,
    classNameCol6,
    classNameCol7,

    select1Options,
    select2Options,
    select3Options,
    select4Options,

    onDateRangeChange,
    onLocationChange,
    onClinicChange,
    onSearchChange,
    onChange3,
    onChange4,

    onSearchClick,

    dateRange,
    select1Value,
    select2Value,
    select3Value,
    select4Value,
    searchValue,

    searchPlaceholder,
    select1Placeholder,
    select2Placeholder,
    select3Placeholder,
    select4Placeholder,
    cDateRangePlaceholder,

    isMulti3,
    isMulti2,

    buttonChildren
}) => {

    return (
        <Row className={`exado-row1 ${className}`}>
            {showDate && (
                <Col lg={datepickerlg} md={datepickermd} xs={datepickerxs} className={`mt-md-0 mt-3 ${classNameCol1}`}>
                    <div className={cDateRangeClassname} >
                        <CustomDatePicker.CustomDateRangePicker
                            dateRange={dateRange}
                            onChange={onDateRangeChange}
                            placeholderText={cDateRangePlaceholder}
                            className="customDateRangePicker"
                        />
                    </div>
                </Col>
            )}
            {showSelect1 && (
                <Col lg={selectCollg1} md={selectColmd1} xs={selectColxs1} className={`mt-md-0 mt-3 ${classNameCol2}`} >
                    <SelectO.SelectO
                        isMulti={true}
                        options={select1Options}
                        value={select1Value}
                        onChange={onLocationChange}
                        className={select1Classname}
                        placeholder={select1Placeholder}
                        components={{ DropdownIndicator: Indicators.DropDownIndicator }}
                        isSearchable={false}
                    />
                </Col>
            )}
            {showSelect2 && (
                <Col lg={selectCollg2} md={selectColmd2} xs={selectColxs2} className={`mt-md-0 mt-3 ${classNameCol3}`}>
                    <SelectO.SelectO
                        options={select2Options}
                        value={select2Value}
                        onChange={onClinicChange}
                        className={select2Classname}
                        placeholder={select2Placeholder}
                        isMulti={isMulti2}
                        components={{ DropdownIndicator: Indicators.DropDownIndicator }}
                        isSearchable={false}
                    />
                </Col>
            )}
            {showSelect3 && (
                <Col lg={selectCollg3} md={selectColmd3} xs={selectColxs3} className={`mt-md-0 mt-3 ${classNameCol4}`} >
                    <SelectO.SelectO
                        options={select3Options}
                        value={select3Value}
                        onChange={onChange3}
                        className={select3Classname}
                        placeholder={select3Placeholder}
                        isMulti={isMulti3}
                        components={{ DropdownIndicator: Indicators.DropDownIndicator }}
                        isSearchable={false}
                    />
                </Col>
            )}
            {showSelect4 && (
                <Col lg={selectCollg4} md={selectColmd4} xs={selectColxs4} className={`mt-md-0 mt-3 ${classNameCol5}`} >
                    <SelectO.SelectO
                        options={select4Options}
                        value={select4Value}
                        onChange={onChange4}
                        className={select4Classname}
                        placeholder={select4Placeholder}

                        components={{ DropdownIndicator: Indicators.DropDownIndicator }}
                        isSearchable={false}
                    />
                </Col>
            )}
            <Col lg={searchCollg} md={searchColmd} xs={selectColxs} className={`mt-md-0 mt-3 ${classNameCol6}`}>
                <Inputs.FormInputs
                    type="search"
                    grpClassname={searchGrpClassName}
                    placeholder={searchPlaceholder}
                    value={searchValue}
                    onChange={onSearchChange}
                    inputIcons={
                        <div className="serchIconBlk">
                            <TbSearch className="serchIcon" />
                        </div>
                    }
                />
            </Col>
            <Col lg={buttonCollg} md={buttonColmd} xs={buttonColxs} className={`mt-md-0 mt-3 ${classNameCol7}`}>
                <Buttton.Buttton
                    children={buttonChildren}
                    className={buttonClassname}
                    onClick={onSearchClick}
                />
            </Col>
        </Row>
    )
}

export default SearchBar
